import * as React from 'react';
import {
  DrawerHeaderNavigation,
  makeStyles,
  shorthands,
  tokens,
  Toolbar,
  ToolbarButton,
} from '@fluentui/react-components';
import { ArrowLeft24Regular, Dismiss24Regular } from '@fluentui/react-icons';
import { defineMessage, useIntl } from 'react-intl';
import type { DrawerNavigationProp } from '../modules/drawer';

export function DrawerNavigation({ onBackButtonClick, closeDrawer }: DrawerNavigationProp) {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <DrawerHeaderNavigation>
      <Toolbar className={classes.toolbar}>
        <ToolbarButton
          aria-label={intl.formatMessage(backButtonLabel)}
          appearance="subtle"
          icon={<ArrowLeft24Regular />}
          onClick={onBackButtonClick}
          autoFocus
        />
        <ToolbarButton
          className={classes.closeButtonHeader}
          aria-label={intl.formatMessage(closeLabel)}
          appearance="subtle"
          icon={<Dismiss24Regular />}
          onClick={closeDrawer}
        />
      </Toolbar>
    </DrawerHeaderNavigation>
  );
}

const closeLabel = defineMessage({
  defaultMessage: 'Close',
  description: 'label for the close button',
});

const backButtonLabel = defineMessage({
  defaultMessage: 'Back',
  description: 'label for the back button',
});

const useStyles = makeStyles({
  closeButtonHeader: {
    ...shorthands.padding(
      tokens.spacingVerticalSNudge,
      tokens.spacingHorizontalSNudge,
      tokens.spacingVerticalSNudge,
      tokens.spacingHorizontalSNudge
    ),
  },
  toolbar: {
    minHeight: '39px', // 39px is to prevent jumping of close button between L1 and L2 header / DrawerHeading vs DrawerNavigation.
    justifyContent: 'space-between',
  },
});
